const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		const elem = entry.target
		elem.classList.add('animation-loaded')
		if (entry.isIntersecting) {
			elem.classList.add('animation-run');
			observer.unobserve(elem)
		}
	});
});

// we add our observer to a wrapper function to more easily call it as a HOF
function addAnimation(elem) {
	observer.observe(elem);
}

document.addEventListener('DOMContentLoaded', () => {
	// gather each impact chunk; loop thru them
	document.querySelectorAll('.content-impact > .chunk').forEach(chunk => {
		// pull in the icon, the header, and any paragraph, as we only have paragraphs at the top
		// of each chunk
		const animatedElems = []
		animatedElems.push(chunk.querySelector("h2")); // the heading and icon
		animatedElems.push(Array.from(chunk.querySelectorAll("& > p"))); // all paragraphs

		// run the animation function on each of these gathered items
		animatedElems.flat().forEach(addAnimation);
	});

	// Add the stat blocks to the animation list as well. At the moment, all the stat blocks are
	// double blocks, so we go specifically for those, to avoid any potential child block problems
	document.querySelectorAll('.wp-block-impact-stat-double').forEach(addAnimation)
})
